import React, { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import SliderTitle from '../sliderTitle/SliderTitle';
import sliderTitleOfferStyles from './sliderTitleOfferStyles';
import PriceBadge from '../../../../presentational/priceBadge/PriceBadge';
import SliderTitleDiscount from '../sliderTitleDiscount/SliderTitleDiscount';
import IMoney from '../../../../../../gqlCommon/model/prices/IMoney';
import { GetCustomizeCar_customizeCar_deliveryTimeFrame } from '../../../../../graphql/queries/__generated__/GetCustomizeCar';

interface ISliderTitleOffer {
  title: string;
  hasOffer: boolean;
  marketingLabel?: string;
  hasStock: boolean;
  fullPrice: number;
  offerPrice: number;
  currency: string;
  stockLink?: {
    url: string;
    label: string;
  };
  totalDiscount: IMoney[];
  isInStock: boolean;
  isPreOrder: boolean;
  deliveryTimeFrame?: GetCustomizeCar_customizeCar_deliveryTimeFrame;
  promotionalLabel?: string;
}

const SliderTitleOffer: FunctionComponent<ISliderTitleOffer> = ({
  title,
  hasOffer,
  marketingLabel,
  hasStock,
  stockLink,
  fullPrice,
  offerPrice,
  currency,
  totalDiscount,
  isInStock,
  isPreOrder,
  deliveryTimeFrame,
  promotionalLabel,
}) => {
  const styles = sliderTitleOfferStyles();

  return (
    <Grid container direction="row" className={styles.container}>
      <Grid item sm={hasOffer || totalDiscount ? 9 : 12} xs={hasOffer || totalDiscount ? 8 : 12}>
        <SliderTitle
          title={title}
          hasStock={hasStock}
          stockLink={stockLink}
          marketingLabel={marketingLabel}
          isInStock={isInStock}
          isPreOrder={isPreOrder}
          deliveryTimeFrame={deliveryTimeFrame}
          promotionalLabel={promotionalLabel}
        />
      </Grid>
      {totalDiscount && (
        <Grid item sm={3} xs={4}>
          <SliderTitleDiscount prices={totalDiscount} currency={currency} />
        </Grid>
      )}
      {
        // TODO: Temporary disable due to market requirement
        hasOffer && false && (
          <Grid item sm={3} xs={3}>
            <PriceBadge fullPrice={fullPrice} offerPrice={offerPrice} currency={currency} />
          </Grid>
        )
      }
    </Grid>
  );
};

export default SliderTitleOffer;
